<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: number = 80;
    export let disabled: boolean = false;
    export let required: boolean = false;

    errors[name] = [];

    const validate = (val: number = value) => {
        errors[name] = [];
        if (required && val === null) {
            errors[name].push('This field is required');
        } else if (val < 0 || val > 65535) {
            errors[name].push('Port must be between 0 and 65535');
        }
    };
    validate();

    const handleInput = (e: Event) => {
        value = parseInt((e.currentTarget as HTMLInputElement).value, 10);
        validate(value);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        type="number"
        {name}
        {disabled}
        {required}
        min="0"
        max="65535"
        value={value}
        on:input={handleInput}
        class="input-mono"
        class:error={errors[name].length > 0}
        on:change
        on:blur
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
